import { DefaultService } from '@/services/DefaultService';

export default class UsuarioService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env)
    }

    save(usuario) {
        return this._http.post(`${this._env}/user/update`, usuario, this._headers).then(
            res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findByLogin(login) {
        return this._http.get(`${this._env}/user/logged.json?login=${login}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    saveGmapsKey(hashedkey) {
        return this._http.post(`${this._env}/user/mapconfig`, hashedkey, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    enviarEmail(mail){
        return this._http.post(`${this._env}/sendmail/excludedata.json`, mail, this._headers).then(res => {
            return res.body;
        },err => {
            this.verifyError(err);
            throw err;
        });
    }

    findAllByIdGrupo(column, order, page, limit, idgrupo, ...params) {
        return this._http.get( encodeURI(`${this._env}/userweb/byidusuarioerp/getbyidusuariogrupoproduto?page=${page}&limit=${limit}&column=${column}&order=${order}&idgrupo=${idgrupo}&param=${params}`), this._headers ).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }
}